import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 26px;
  max-width: 580px;
  width: 100%;
`
export const CollapseWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  width: 100%;
`
export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  width: 100%;
  cursor: pointer;
`
export const CheckMarkIcon = styled.div`
  min-width: 14px;
  min-height: 8px;
`
export const Title = styled.div`
  color: #181833;
  font-family: Gilroy, sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;

  @media screen and (max-width: 767px) {
    font-size: 16px;
    font-weight: 500;
  }
`
export const CollapseText = styled.div<{ isActive: boolean }>`
  display: ${p => (p.isActive ? 'block' : 'none')};
  color: #181833;
  font-family: Gilroy, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;

  @media screen and (max-width: 767px) {
    font-size: 14px;
    font-weight: 400;
  }
`
